import HomeContent from '../../components/User/Home'
import Header from '../../components/Layouts/User/Header'

const Home = () => {

    return (
        <>

            {/* <Header title='خانه' />   */}

            <HomeContent />

        </>
    )

}

export default Home